const TOKEN_KEY = 'googleTokens';

export default {
  saveToken(tokenData) {
    localStorage.setItem(TOKEN_KEY, tokenData);
  },
  
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  
  isAuthenticated() {
    const token = this.getToken();
    return !!token;
  },
  
  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }
};